import elGR from 'antd/es/locale/el_GR';
import enGB from 'antd/es/locale/en_GB';

export const languages = [
  { id: 'el', antd: elGR, moment: 'el', label: 'Ελληνικά', default: true },
  { id: 'en', antd: enGB, moment: 'en-gb', label: 'English' },
];
